import MuiChip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import { alpha, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { FunctionComponent, MouseEventHandler, ReactElement } from 'react';

import { SpacingMultiple } from '../constants';

const StyledLabel = styled(Grid)(({ theme }) => ({
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: theme.spacing(SpacingMultiple.small),
    justifyContent: 'center',
    paddingInline: 0,
}));

const StyledMuiChip = styled(MuiChip)(({ theme }) => ({
    '& .MuiChip-deleteIcon': {
        color: theme.palette.text.primary,
    },
    '& .MuiChip-deleteIcon:hover': {
        color: theme.palette.text.primary,
    },
    '&.inactive': {
        borderColor: 'transparent',
        [`${StyledLabel}`]: { opacity: 0.6 },
    },

    backgroundColor: alpha(theme.palette.text.primary, 0.04),
    borderColor: theme.palette.text.primary,
    borderStyle: 'solid',
    borderWidth: 1,
    color: theme.palette.text.primary,
    cursor: 'pointer',
    fontSize: 14,
}));

type InteractiveChipLabelProps = {
    readonly text: string;
};

const InteractiveChipLabel: FunctionComponent<InteractiveChipLabelProps> = ({ text }) => (
    <StyledLabel container={true}>
        <Typography
            sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}
            variant="body1"
        >
            {text}
        </Typography>
    </StyledLabel>
);

export type InteractiveChipProps = {
    // biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration
    readonly icon: ReactElement<any>;
    readonly isActive?: boolean | undefined;
    readonly label: string;
    readonly onDelete: MouseEventHandler<HTMLDivElement>;
};

export const InteractiveChip: FunctionComponent<InteractiveChipProps> = ({ icon, isActive, label, onDelete }) => (
    <StyledMuiChip
        className={isActive === false ? 'inactive' : ''}
        deleteIcon={icon}
        label={<InteractiveChipLabel text={label} />}
        size="small"
        onClick={onDelete}
        onDelete={onDelete}
    />
);
